import type { CSSProperties } from "react";

export const ACTIONS: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  flexWrap: "wrap",
};

export const HINT: CSSProperties = {
  margin: 0,
  fontSize: "0.71875rem",
  lineHeight: 1.5,
  color: "var(--fg-2)",
};
